import { render, staticRenderFns } from "./M22_S20.vue?vue&type=template&id=d669bdce&scoped=true"
import script from "./M22_S20.vue?vue&type=script&lang=js"
export * from "./M22_S20.vue?vue&type=script&lang=js"
import style0 from "./M22_S20.vue?vue&type=style&index=0&id=d669bdce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d669bdce",
  null
  
)

export default component.exports